module.exports = __webpack_public_path__ + "static/media/check-mark.efa3f775.png";